import { createResourceQuery } from '@faro/resource-query';
import { StudySpace } from '@faro/study-space-service-model';
import { ServiceContextValue } from '../../context/Service/ServiceContext';
import { DiseaseArea, studySpaceEntityType } from '../../service';

interface SpacePageData {
    spaces: StudySpace[];
    diseaseAreas: DiseaseArea[];
}
type SpacePageDataQuery = undefined;
interface ResolverArgs {
    context: ServiceContextValue;
}
export const useSpacesPageData = createResourceQuery<
    SpacePageData,
    SpacePageDataQuery,
    ServiceContextValue,
    Error,
    ResolverArgs
>({
    resolve: async ({ context }: ResolverArgs) => {
        const { studySpaceService, diseaseAreasService } = context;
        const [spaces, diseaseAreas] = await Promise.all([studySpaceService.list(), diseaseAreasService.list()]);
        return {
            spaces,
            diseaseAreas,
        };
    },
    queryKeys: [studySpaceEntityType],
    id: 'spacesPageData',
});
